<template>
  <div>
    <p>
      <strong>{{ $t('contract.working_hours.headlines.first') }}</strong>
    </p>
    <p>
      <strong>{{ $t('contract.working_hours.headlines.second') }}</strong>
    </p>

    <transition-group name="highlight">
      <div key="a" v-if="options.A_fullTimeSelected || options.A_otherSelected || showAll">
        <working-hours-output-a />
      </div>
      <div key="b" v-if="options.B_selected || showAll">
        <working-hours-output-b />
      </div>
      <div key="c" v-if="options.C_selected || showAll">
        <working-hours-output-c />
      </div>
    </transition-group>
    
    <p>{{ $t('contract.working_hours.paragraphs.overtime') }}</p>
    <hr />
  </div>
</template>

<script>
import WorkingHoursOutputA from "./WorkingHoursOutputA";
import WorkingHoursOutputB from "./WorkingHoursOutputB";
import WorkingHoursOutputC from "./WorkingHoursOutputC";
export default {
  components: {
    WorkingHoursOutputA,
    WorkingHoursOutputB,
    WorkingHoursOutputC
  },
  computed: {
    options() {
      return this.$store.state.contract.workingHours.options;
    },
    showAll() {
      return (
        this.options.A_fullTimeSelected === false &&
        this.options.A_otherSelected === false &&
        this.options.B_selected === false &&
        this.options.C_selected === false
      );
    }
  }
};
</script>
